import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTE_META, DEFAULT_META, SITE_URL, OG_IMAGE } from "./siteMeta";

const setMeta = (selector, attr, key, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Per-route title, description, canonical and Open Graph tags. The prerender
// step (scripts/prerender.js) runs the app and snapshots the result, so these
// end up in the static HTML that crawlers and link unfurlers read.
export default function useSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[pathname] || DEFAULT_META;
    const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;

    document.title = meta.title;
    setMeta('meta[name="description"]', "name", "description", meta.description);
    setMeta('meta[property="og:title"]', "property", "og:title", meta.title);
    setMeta(
      'meta[property="og:description"]',
      "property",
      "og:description",
      meta.description
    );
    setMeta('meta[property="og:url"]', "property", "og:url", url);
    setMeta('meta[property="og:image"]', "property", "og:image", OG_IMAGE);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", meta.title);
    setMeta(
      'meta[name="twitter:description"]',
      "name",
      "twitter:description",
      meta.description
    );
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", OG_IMAGE);
    setCanonical(url);
  }, [pathname]);
}
